import type { SxProps, Theme } from '@mui/material';

export const readingTitleSx: SxProps<Theme> = {
  mb: 1,
};

export const readingDescriptionSx: SxProps<Theme> = {
  opacity: 0.7,
};

export const readingAlertSx: SxProps<Theme> = {
  mt: 2,
};
